import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const StopClockResetIcon = ({
  color = RoutalPalette.primary40,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} viewBox="0 0 25 25" style={{ width: `20px`, height: `20px`, ...props.style }}>
      <g fill="none">
        <path
          d="M12.25 22.2339C17.7728 22.2339 22.25 17.7567 22.25 12.2339C22.25 6.71104 17.7728 2.23389 12.25 2.23389C6.72715 2.23389 2.25 6.71104 2.25 12.2339C2.25 17.7567 6.72715 22.2339 12.25 22.2339Z"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect x="8.75" y="8.73389" width="7" height="7" rx="0.5" fill={color} stroke={color} />
      </g>
    </SvgIcon>
  );
};
